import { z } from "zod";

export const workTypeSchema = z.object({
  name: z.string().min(1, "El nombre es requerido").max(100),
  mold_capture: z.enum(["0", "1", "2"], {
    required_error: "Seleccione una opción de captura de molde"
  }),
  element_type: z.enum(["Pieza", "Lote", "Maquina"], {
    required_error: "Seleccione un tipo de elemento"
  }),
  requires_machine: z.boolean().default(false),
  is_active: z.boolean().default(true)
});

export type WorkTypeFormData = z.infer<typeof workTypeSchema>;

export const galleryImageSchema = z.object({
  element_id: z.string().uuid(),
  element_type: z.enum(["mold", "work_order", "product_model", "machine", "batch", "customer"]),
  image_url: z.string().url("Ingrese una URL válida"),
  description: z.string().optional()
});

export type GalleryImageFormData = z.infer<typeof galleryImageSchema>;

export const productModelWorkTypeSchema = z.object({
  product_model_id: z.string().uuid(),
  work_type_id: z.string().uuid(),
  manual_url: z.string().url("Ingrese una URL válida").optional().or(z.literal(""))
});

export type ProductModelWorkTypeFormData = z.infer<typeof productModelWorkTypeSchema>;
